export const DESTROY_SESSION = 'DESTROY_SESSION'

export const DestroySession = () => ({
    type: DESTROY_SESSION,
})


// WEBPACK FOOTER //
// ./src/store/global/actions.js